module.exports = __webpack_public_path__ + "img/blue-circle.49511dc0.svg";